import styled from 'styled-components';
import { Badge, TextButton } from '@oneaudi/unified-web-components';
import {
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_RELATIVE_2_XL,
  SYS_SPACE_RELATIVE_XL,
} from '@oneaudi/unified-web-common';
import { dynamicStylingHelper, GetSafeColorDesignToken } from '@oneaudi/vtp-shared';
import { SYS_COLOR_CANVAS_200_DARK } from '@oneaudi/unified-web-alpha-common';

export const StyledContainer = styled.div<{ isFavorites: boolean }>`
  display: flex;
  justify-content: ${(props) => (props.isFavorites ? 'space-between' : 'flex-end')};
  align-items: center;
  align-self: stretch;
  padding: ${SYS_SPACE_FIXED_200} 0 ${SYS_SPACE_FIXED_200};
  margin-bottom: ${SYS_SPACE_RELATIVE_2_XL};
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${dynamicStylingHelper(
    SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
    SYS_COLOR_CANVAS_200_DARK
  )};
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-bottom: ${SYS_SPACE_RELATIVE_XL};
  }
`;

export const FavsAndLocWrapper = styled.div`
  display: flex;
  min-height: 32px;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${parseInt(SYS_BREAKPOINT_LG, 10) - 1}px) {
    width: 100%;
  }
`;

export const StyledTextButton = styled(TextButton)`
  padding: ${dynamicStylingHelper('0px')};
`;

export const StyledToolButton = styled(TextButton)`
  padding: ${dynamicStylingHelper(`${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_150}`)};
`;

export const StyledCount = styled(Badge)`
  background-color: ${GetSafeColorDesignToken('interactive-light')};
`;

export const ResposiveFilterBtnContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-inline-end: 8px;
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: none;
  }
`;
export const ToolBarSkeletonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${SYS_SPACE_RELATIVE_XL};
`;
